define('components/course/models/slide-type/background-theme-selection',[
    "components/course/models/slide-type/zeus-base",
    "components/background-theme-selection-component/collections/theme-collection"
], function(BaseModel, ThemeCollectionClass) {
    "use strict";

    var BackgroundThemeSelectionModel = BaseModel.extend({
        "BackgroundThemeSelectionComponentModel": null,
        "defaults": function() {
            var baseDefaults = BaseModel.prototype.defaults.apply(this, arguments),
                backgroundThemeSelectionDefaults = {
                    "type": "background-theme-selection",
                    "data": {
                        "themeCollectionData": [],
                        "themeSlideTitle": "",
                        "saveState": {
                            "currentlySelectedThemeIndex": null
                        }
                    },
                    "themeCollection": null
                };

            return _.extend(baseDefaults, backgroundThemeSelectionDefaults);
        },

        "initialize": function() {
            this._populateData();
            this._createThemeCollection();
        },

        "authoringJSONKey": function() {
            return _.extend(BaseModel.prototype.authoringJSONKey.call(this), {
                "data": {
                    "themeCollectionData": null,
                    "themeSlideTitle": null,
                    "globalComponentData": null
                }
            });
        },

        "_populateData": function() {
            var data = this.get('data');

            if (!data) {
                this.set('data', {
                    "themeCollectionData": []
                });
            }
            if (data && !data.saveState) {
                this.set('data', _.extend(data, {
                    "saveState": {
                        "currentlySelectedThemeIndex": null
                    }
                }));
            }
        },

        "_createThemeCollection": function() {
            this.set('themeCollection', new ThemeCollectionClass(this.get('data').themeCollectionData));
        }

    }, {
        "MAX_NUMBER_OF_THEMES": 4,

        "MIN_NUMBER_OF_THEMES": 1,

        "EVENTS": {
            "GET_SAVE_STATE": "get-save-state",
            "BACKGROUND_THEME_SELECTED": "background-theme-selected",
            "BACKGROUND_THEME_DESELECTED": "background-theme-deselected"
        }
    });
    return BackgroundThemeSelectionModel;
});

